import { graphql, Link, useStaticQuery } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useState } from "react"
import "./Footer.css"

function Footer() {
  const [showButton, setShowButton] = useState(false)
  const [isActive, setIsActive] = useState(false)
  const [localStorageValue, setLocalStorageValue] = useState(false)

  const handleCloseClick = e => {
    setIsActive(!isActive)
    setTimeout(() => {
      document.querySelector("body").classList.add("close-popup-newsletter")
      setIsActive(true)
    }, 2000)
  }

  useEffect(() => {
    if (typeof window !== "undefined" && localStorageValue) {
      localStorage.setItem("subscribedToNewsletter", "true")
    }
  }, [localStorageValue])

  useEffect(() => {
    if (typeof window !== "undefined") {
      const userSubscribed = localStorage.getItem("subscribedToNewsletter")
      if (!userSubscribed) {
        setTimeout(() => {
          document.querySelector(".newsletter-popup").style.display = "block"
          document.querySelector("body").addEventListener("click", e => {
            if (
              !e.target.classList.contains("newsletter-popup") &&
              !e.target.classList.contains("no-click-listener")
            ) {
              setIsActive(!isActive)
              setTimeout(() => {
                document
                  .querySelector("body")
                  .classList.add("close-popup-newsletter")
                setIsActive(true)
              }, 400)
            }
          })
        }, 10000)
      }
    }
  }, [])

  if (typeof window !== "undefined") {
    window.addEventListener("scroll", () => {
      if (window.pageYOffset > 300) {
        setShowButton(true)
      } else {
        setShowButton(false)
      }
    })
  }

  const scrollToTop = () => {
    document.documentElement.style.scrollBehavior = "smooth"
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    })
    setTimeout(() => {
      document.documentElement.style.scrollBehavior = "auto"
    }, 2000)
  }

  const showNewsletterThankYouMessage = () => {
    const newsletterFormWrapper = document.querySelector(".newsletter-form")
    const paragraph = document.createElement("p")
    paragraph.classList.add("newsletter-message")
    paragraph.innerText = "Thank you for signing up to our newsletter!"
    newsletterFormWrapper.appendChild(paragraph)
  }
  const showSignupThankYouMessage = () => {
    const signupFormWrapper = document.querySelector(".signup-form")
    const paragraph = document.createElement("p")
    paragraph.classList.add("signup-message")
    paragraph.innerText = "Thank you for signing up to our newsletter!"
    signupFormWrapper.appendChild(paragraph)
  }

  const footerData = useStaticQuery(graphql`
    query {
      wp {
        fluxDnaSettings {
          fluxDna {
            footerFormHeading
            newsletterFormHeading
            newsletterLeftHeading
            newsletterLeftDescription
            newsletterLeftButton{
              target
              title
              url
            }
            footerLogo {
              altText
              mediaItemUrl
            }
            footerMenu {
              menu {
                target
                title
                url
              }
            }
            socialMedia {
              socialIcon {
                altText
                mediaItemUrl
              }
              socialLink
            }
          }
        }
      }
    }
  `)
  const footerDataList = footerData.wp.fluxDnaSettings.fluxDna
  const [isLadoing, setIsLoading] = useState(false)
  const [form, setForm] = useState({
    input_2: "",
    input_3: "",
    input_4: "",
  })

  const [formError, setFormError] = useState({
    input_2: "",
    input_3: "",
    input_4: "",
  })

  const [isLadoingSignup, setIsLoadingSignup] = useState(false)
  const [formSignup, setFormSignup] = useState({
    input_2: "",
    input_4: "",
  })

  const [formErrorSignup, setFormErrorSignup] = useState({
    input_2: "",
    input_4: "",
  })

  return (
    <React.Fragment>
      <footer className="bg-stone">
        <div className="container-fluid mdscreen:!w-full mdscreen:!px-0">
          <div className="bg-charcoal">
            {footerDataList?.footerLogo && (
              <div className="logo text-center py-40">
                <Link to="/">
                  <img
                    src={footerDataList.footerLogo.mediaItemUrl}
                    loading="lazy"
                    width={236}
                    height={160}
                    alt={footerDataList.footerLogo.altText}
                    className="mx-auto smscreen2:max-w-[180px]"
                  />
                </Link>
              </div>
            )}
            <div className="flex flex-wrap">
              <div className="lg:w-6/12 w-full border-t-1 md:border-r-1 border-white-100 border-opacity-60">
                <div className="footer-navbar px-120 py-70 laptop:px-50 lgscreen:px-30 lgscreen:py-40">
                  {footerDataList?.footerMenu && (
                    <ul className="grid grid-cols-2 gap-y-1 gap-x-12 laptop:gap-x-4 smscreen2:grid-cols-1 menuHover menuHoverwhite smscreen2:text-center">
                      {footerDataList.footerMenu.map((item, i) => (
                        <li key={i}>
                          <Link
                            to={item.menu.url}
                            target={item.menu.target}
                            className="text-white-100 uppercase text-17 tracking-05em"
                          >
                            {parse(item.menu.title)}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                  {footerDataList?.socialMedia && (
                    <div className="sicon flex flex-wrap mt-30 gap-x-4 smscreen2:justify-center">
                      {footerDataList.socialMedia.map((social, j) => (
                        <Link
                          to={social.socialLink}
                          className="transition-all duration-300"
                          key={j}
                          target="_blank"
                        >
                          <img
                            src={social.socialIcon.mediaItemUrl}
                            width={33}
                            height={33}
                            loading="lazy"
                            alt={social.socialIcon.altText}
                          />
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              </div>
              <div className="lg:w-6/12 w-full">
                <div className="newsletter border-t-1 border-t-white-100 border-opacity-60 pt-75 pb-110 pl-[98px] pr-110 laptop:px-50 lgscreen:px-30 lgscreen:py-40">
                  {footerDataList?.footerFormHeading && (
                    <h6 className="text-white-100 uppercase text-[20px] leading-22 tracking-05em smscreen2:text-center">
                      {footerDataList.footerFormHeading}
                    </h6>
                  )}
                  <div className="gform_wrapper">
                    <ul className="flex flex-wrap justify-between smscreen2:flex-col -mx-30 mt-30">
                      <li className="w-6/12 smscreen2:w-full">
                        <input
                          type="text"
                          className="text-15 mdscreen:text-16 tracking-05em normal-case text-white-100 outline-none placeholder:text-white-100 placeholder:text-opacity-80 pb-[8px] pl-5"
                          value={form.input_2}
                          onChange={e => {
                            setForm({
                              ...form,
                              input_2: e.target.value,
                            })
                            setFormError({
                              ...formError,
                              input_2: "",
                            })
                          }}
                          placeholder="Name"
                        />
                        {formError.input_2 && (
                          <div className="error">
                            <span className="text-red">
                              {formError.input_2}
                            </span>
                          </div>
                        )}
                      </li>
                      <li className="w-6/12 smscreen2:w-full">
                        <input
                          type="text"
                          className="text-15 mdscreen:text-16 tracking-05em normal-case text-white-100 outline-none placeholder:text-white-100 placeholder:text-opacity-80 pb-[8px] pl-5"
                          value={form.input_3}
                          onChange={e => {
                            setForm({
                              ...form,
                              input_3: e.target.value,
                            })
                            setFormError({
                              ...formError,
                              input_3: "",
                            })
                          }}
                          placeholder="Surname"
                        />
                        {formError.input_3 && (
                          <div className="error">
                            <span className="text-red">
                              {formError.input_3}
                            </span>
                          </div>
                        )}
                      </li>
                      <li className="w-full">
                        <input
                          type="text"
                          className="text-15 mdscreen:text-16 tracking-05em normal-case text-white-100 outline-none placeholder:text-white-100 placeholder:text-opacity-80 pb-[8px] pl-5"
                          value={form.input_4}
                          onBlur={e => {
                            var value = e.target.value
                            var pattern =
                              /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
                            if (!pattern.test(value)) {
                              setForm({ ...form, input_4: "" })
                              setFormError({
                                ...formError,
                                input_4: "Please enter valid email",
                              })
                            }
                          }}
                          onChange={e => {
                            setForm({
                              ...form,
                              input_4: e.target.value,
                            })
                            setFormError({
                              ...formError,
                              input_4: "",
                            })
                          }}
                          placeholder="Email Address"
                        />
                        {formError.input_4 && (
                          <div className="error">
                            <span className="text-red">
                              {formError.input_4}
                            </span>
                          </div>
                        )}
                      </li>
                    </ul>
                    <div className="gform_footer mt-25">
                      <button
                        className="btn btn-transparent cursor-pointer"
                        onClick={() => {
                          var validRegex =
                            /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
                          setFormError({
                            ...formError,
                            input_2:
                              form.input_2 === "" ? "Please enter name" : "",
                            input_3:
                              form.input_3 === "" ? "Please enter surname" : "",
                            input_4:
                              form.input_4 === "" ||
                                !form.input_4.match(validRegex)
                                ? "Please enter valid email"
                                : "",
                          })

                          if (
                            form.input_4 !== "" &&
                            form.input_2 !== "" &&
                            form.input_3 !== ""
                          ) {
                            document.body.classList.add("loader")
                            setIsLoading(true)
                            const requestOptions = {
                              method: "POST",
                              headers: { "Content-Type": "application/json" },
                              body: JSON.stringify(form),
                            }
                            const url = `${process.env.GATSBY_SITE_URL}wp-json/gf/v2/forms/${process.env.GATSBY_NEWSLETTER_FORM_ID}/submissions`
                            setFormError({
                              ...formError,
                            })
                            fetch(url, requestOptions).then(response => {
                              if (response.status === 200) {
                                document.body.classList.remove("loader")
                                setIsLoading(false)
                                showNewsletterThankYouMessage()
                              } else {
                                setFormError({
                                  ...formError,
                                })
                              }
                            })
                          }
                        }}
                      >
                        {isLadoing ? "Loading" : "sign up for our newsletter"}
                      </button>
                    </div>
                    <div className="newsletter-form mt-10"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="backtotop text-center py-25">
            <Link to="">
              <div className="flex flex-wrap gap-x-2 justify-center">
                {showButton && (
                  <button
                    onClick={scrollToTop}
                    className="back-to-top flex flex-wrap gap-x-2 justify-center"
                  >
                    <img
                      src="../../../images/tools_ladder.svg"
                      alt="tools_ladder"
                      width="10"
                      height="15"
                      loading="lazy"
                    />
                    <span className="text-14 text-charcoal tracking-05em uppercase">
                      Back To Top
                    </span>
                  </button>
                )}
              </div>
            </Link>
          </div>
        </div>

        <div
          className={`newsletter-popup fixed bottom-0 right-0 mobileLandscape:pb-[8px] z-999 popup mdscreen2:h-[calc(100dvh_-_88px)] mdscreen2:overflow-y-auto ${isActive ? "close-popup" : "page-popup"
            } `}
          style={{ display: "none" }}
        >
          <div className="flex flex-wrap w-full max-w-[790px] mdscreen2:max-w-[395px] mdscreen2:h-full">
            <div className="popup-content-left py-85 px-70 w-6/12 bg-gray-100 mdscreen2:w-full">
              <div className="flex flex-col justify-between h-full gap-[15px]">
                <div className="title-wrapper">
                  {footerDataList?.newsletterLeftHeading && (
                    <h6 className="no-click-listener text-black-100 uppercase text-[24px] leading-[28px] tracking-05em">{footerDataList.newsletterLeftHeading}</h6>
                  )}
                  {footerDataList?.newsletterLeftDescription && (
                    <div className="content black pt-15">
                      <p>{footerDataList.newsletterLeftDescription}</p>
                    </div>
                  )}
                </div>
                {footerDataList?.newsletterLeftButton && (
                  <div className="btn-custom">
                    <Link to={footerDataList.newsletterLeftButton.url} target={footerDataList.newsletterLeftButton.target} className="btn btn-border w-full text-center">{footerDataList.newsletterLeftButton.title}</Link>
                  </div>
                )}
              </div>
            </div>
            <div className="popup-content-right bg-charcoal py-85 px-65 w-6/12 mdscreen2:w-full">
              <button
                onClick={handleCloseClick}
                className="absolute top-15 right-15 p-10"
              >
                <img
                  src="../../../images/close-white.svg"
                  width="16"
                  height="16"
                  alt="close"
                  loading="lazy"
                  className="mdscreen2:filter-black"
                />
              </button>
              {footerDataList?.newsletterFormHeading && (
                <h6 className="no-click-listener text-white-100 uppercase text-[24px] leading-[28px] tracking-05em">
                  {footerDataList.newsletterFormHeading}
                </h6>
              )}
              <div className="gform_wrapper no-click-listener">
                <ul className="flex flex-col justify-between smscreen2:flex-col -mx-30 mt-30 mobileLandscape:mt-15 no-click-listener">
                  <li>
                    <input
                      type="text"
                      className="text-13 mdscreen:text-16 tracking-05em normal-case text-white-100 outline-none placeholder:text-white-100 placeholder:text-opacity-80 pb-[8px] pl-5 no-click-listener"
                      value={formSignup.input_2}
                      onChange={e => {
                        setFormSignup({
                          ...formSignup,
                          input_2: e.target.value,
                        })
                        setFormErrorSignup({
                          ...formErrorSignup,
                          input_2: "",
                        })
                      }}
                      placeholder="Full Name"
                    />
                    {formErrorSignup.input_2 && (
                      <div className="error no-click-listener">
                        <span className="text-red">
                          {formErrorSignup.input_2}
                        </span>
                      </div>
                    )}
                  </li>
                  <li>
                    <input
                      type="text"
                      className="text-13 mdscreen:text-16 tracking-05em normal-case text-white-100 outline-none placeholder:text-white-100 placeholder:text-opacity-80 pb-[8px] pl-5 no-click-listener"
                      value={formSignup.input_4}
                      onBlur={e => {
                        var value = e.target.value
                        var pattern =
                          /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
                        if (!pattern.test(value)) {
                          setFormSignup({ ...formSignup, input_4: "" })
                          setFormErrorSignup({
                            ...formErrorSignup,
                            input_4: "Please enter valid email.",
                          })
                        }
                      }}
                      onChange={e => {
                        setFormSignup({
                          ...formSignup,
                          input_4: e.target.value,
                        })
                        setFormErrorSignup({
                          ...formErrorSignup,
                          input_4: "",
                        })
                      }}
                      placeholder="Email Address"
                    />
                    {formErrorSignup.input_4 && (
                      <div className="error no-click-listener">
                        <span className="text-red">
                          {formErrorSignup.input_4}
                        </span>
                      </div>
                    )}
                  </li>
                </ul>
                <span className="text-[10.5px] opacity-50 leading-12 mdscreen:text-14 mdscreen:leading-18 text-white-100  inline-block no-click-listener">
                  *By signing up for this newsletter you are consenting to receiving emails from the full Kove Collection of properties
                </span>
                <div className="gform_footer mt-25 mobileLandscape:mt-15 no-click-listener">
                  <button
                    className="btn btn-white cursor-pointer no-click-listener mdscreen2:w-full"
                    onClick={() => {
                      var validRegex =
                        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
                      setFormErrorSignup({
                        ...formErrorSignup,
                        input_2:
                          formSignup.input_2 === "" ? "Please enter name." : "",
                        input_4:
                          formSignup.input_4 === "" ||
                            !formSignup.input_4.match(validRegex)
                            ? "Please enter valid email."
                            : "",
                      })

                      if (
                        formSignup.input_4 !== "" &&
                        formSignup.input_2 !== ""
                      ) {
                        document.body.classList.add("loader")
                        setIsLoadingSignup(true)
                        const requestOptions = {
                          method: "POST",
                          headers: { "Content-Type": "application/json" },
                          body: JSON.stringify(formSignup),
                        }
                        const url = `${process.env.GATSBY_SITE_URL}wp-json/gf/v2/forms/${process.env.GATSBY_SIGNUP_FORM_ID}/submissions`
                        setFormErrorSignup({
                          ...formErrorSignup,
                        })
                        fetch(url, requestOptions).then(response => {
                          if (response.status === 200) {
                            document.body.classList.remove("loader")
                            setLocalStorageValue(true)
                            setIsLoadingSignup(false)
                            showSignupThankYouMessage()
                          } else {
                            setFormErrorSignup({
                              ...formErrorSignup,
                            })
                          }
                        })
                      }
                    }}
                  >
                    {isLadoingSignup ? "Loading" : "sign up"}
                  </button>
                </div>
                <div className="signup-form mt-10 no-click-listener"></div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </React.Fragment>
  )
}

export default Footer
